import React from 'react';
import painterRegistry from '../Widgets/DataPainterWidget/Core/PainterRegistry'; // hergebruik van bestaand mount-mechanisme, GEEN data-pijplijn (zie design V1)
import UmlCanvas from './UI/UmlCanvas/UmlCanvas.jsx';

// Entry point. Compositie van UmlCanvas — geen Provider, geen Context
// (Feature Folder Structure rk=bb7aae5fec594753aa4df499ae73ed59).
// Geen fetch-bij-mount — canvas toont gewoon wat er in umlCanvasEngine zit,
// dat wordt gevuld via New/Load Uml in UmlSchemaConfigDlg, niet hier.
function UmlWorkspaceWidget() {
    return <UmlCanvas />;
}

painterRegistry.register('uml:workspace:1', UmlWorkspaceWidget);

export default UmlWorkspaceWidget;
